import { render, staticRenderFns } from "./InformacionGeneralView.vue?vue&type=template&id=5047f0c4&scoped=true"
import script from "./InformacionGeneralView.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralView.vue?vue&type=script&lang=js"
import style0 from "./InformacionGeneralView.vue?vue&type=style&index=0&id=5047f0c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5047f0c4",
  null
  
)

export default component.exports